export enum Modules {
  NEWS_MODULE = 'newsModule',
  BILLING_MODULE = 'billingModule',
  BONUS_MODULE = 'bonusModule',
  CLEARANCE_MODULE = 'clearanceModule',
  ZIPCODE_MODULE = 'zipCodeModule'
}
